import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineStore } from 'pinia';
import { getAllSubOrganizers } from '~/utils/permissions';
var getDefaultState = function getDefaultState() {
  return {
    loggedIn: false,
    user: {
      id: null,
      username: null,
      email: null,
      enrollmentId: null,
      guestId: null,
      verified: false,
      phoneVerified: false,
      mfaEnabled: false,
      firstName: null,
      lastName: null,
      street1: null,
      street2: null,
      city: null,
      state: null,
      country: null,
      zip: null,
      phone: null,
      dateOfBirth: null,
      gender: null,
      description: null,
      pictureUrl: null,
      permissions: {}
    }
  };
};

// Permission helper functions
function canGrantAccountPerms(state, org) {
  var _state$user$permissio, _state$user$permissio2;
  return (_state$user$permissio = state.user.permissions[org]) === null || _state$user$permissio === void 0 ? void 0 : (_state$user$permissio2 = _state$user$permissio.org_level) === null || _state$user$permissio2 === void 0 ? void 0 : _state$user$permissio2.includes('account.change_permissions');
}
function canGrantEventPerms(state, org) {
  var _state$user$permissio3, _state$user$permissio4;
  return (_state$user$permissio3 = state.user.permissions[org]) === null || _state$user$permissio3 === void 0 ? void 0 : (_state$user$permissio4 = _state$user$permissio3.org_level) === null || _state$user$permissio4 === void 0 ? void 0 : _state$user$permissio4.includes('event.change_permissions');
}
function canGrantBcPerms(state, org) {
  var _state$user$permissio5, _state$user$permissio6;
  return (_state$user$permissio5 = state.user.permissions[org]) === null || _state$user$permissio5 === void 0 ? void 0 : (_state$user$permissio6 = _state$user$permissio5.org_level) === null || _state$user$permissio6 === void 0 ? void 0 : _state$user$permissio6.includes('bc.change_permissions');
}
function canGrantPaymentPerms(state, org) {
  var _state$user$permissio7, _state$user$permissio8;
  return (_state$user$permissio7 = state.user.permissions[org]) === null || _state$user$permissio7 === void 0 ? void 0 : (_state$user$permissio8 = _state$user$permissio7.org_level) === null || _state$user$permissio8 === void 0 ? void 0 : _state$user$permissio8.includes('payment.change_permissions');
}
function _canInviteUser(state, org) {
  var _state$user$permissio9, _state$user$permissio0;
  return (_state$user$permissio9 = state.user.permissions[org]) === null || _state$user$permissio9 === void 0 ? void 0 : (_state$user$permissio0 = _state$user$permissio9.org_level) === null || _state$user$permissio0 === void 0 ? void 0 : _state$user$permissio0.includes('account.user.create');
}
function canEditUser(state, org) {
  var _state$user$permissio1, _state$user$permissio10;
  return (_state$user$permissio1 = state.user.permissions[org]) === null || _state$user$permissio1 === void 0 ? void 0 : (_state$user$permissio10 = _state$user$permissio1.org_level) === null || _state$user$permissio10 === void 0 ? void 0 : _state$user$permissio10.includes('account.user.update');
}
function canViewUser(state, org) {
  var _state$user$permissio11, _state$user$permissio12;
  return (_state$user$permissio11 = state.user.permissions[org]) === null || _state$user$permissio11 === void 0 ? void 0 : (_state$user$permissio12 = _state$user$permissio11.org_level) === null || _state$user$permissio12 === void 0 ? void 0 : _state$user$permissio12.includes('account.user.view');
}
function canDeleteUser(state, org) {
  var _state$user$permissio13, _state$user$permissio14;
  return (_state$user$permissio13 = state.user.permissions[org]) === null || _state$user$permissio13 === void 0 ? void 0 : (_state$user$permissio14 = _state$user$permissio13.org_level) === null || _state$user$permissio14 === void 0 ? void 0 : _state$user$permissio14.includes('account.user.delete');
}
function canListUsers(state, org) {
  var _state$user$permissio15, _state$user$permissio16;
  return (_state$user$permissio15 = state.user.permissions[org]) === null || _state$user$permissio15 === void 0 ? void 0 : (_state$user$permissio16 = _state$user$permissio15.org_level) === null || _state$user$permissio16 === void 0 ? void 0 : _state$user$permissio16.includes('account.user.list');
}
function canCreateEvent(state, org) {
  var _state$user$permissio17, _state$user$permissio18;
  return (_state$user$permissio17 = state.user.permissions[org]) === null || _state$user$permissio17 === void 0 ? void 0 : (_state$user$permissio18 = _state$user$permissio17.org_level) === null || _state$user$permissio18 === void 0 ? void 0 : _state$user$permissio18.includes('bc.event.create');
}
function canListEvents(state, org) {
  var _state$user$permissio19, _state$user$permissio20;
  return (_state$user$permissio19 = state.user.permissions[org]) === null || _state$user$permissio19 === void 0 ? void 0 : (_state$user$permissio20 = _state$user$permissio19.org_level) === null || _state$user$permissio20 === void 0 ? void 0 : _state$user$permissio20.includes('event.event.list');
}
function canCreateLocation(state, org) {
  var _state$user$permissio21, _state$user$permissio22;
  return (_state$user$permissio21 = state.user.permissions[org]) === null || _state$user$permissio21 === void 0 ? void 0 : (_state$user$permissio22 = _state$user$permissio21.org_level) === null || _state$user$permissio22 === void 0 ? void 0 : _state$user$permissio22.includes('event.event.create');
}
function canUpdateOrganizer(state, org) {
  var _state$user$permissio23, _state$user$permissio24;
  return (_state$user$permissio23 = state.user.permissions[org]) === null || _state$user$permissio23 === void 0 ? void 0 : (_state$user$permissio24 = _state$user$permissio23.org_level) === null || _state$user$permissio24 === void 0 ? void 0 : _state$user$permissio24.includes('account.organization.update');
}
function canViewOrganizer(state, org) {
  var _state$user$permissio25, _state$user$permissio26;
  return (_state$user$permissio25 = state.user.permissions[org]) === null || _state$user$permissio25 === void 0 ? void 0 : (_state$user$permissio26 = _state$user$permissio25.org_level) === null || _state$user$permissio26 === void 0 ? void 0 : _state$user$permissio26.includes('account.organization.view');
}
function canViewEvent(state, org) {
  var _state$user$permissio27, _state$user$permissio28;
  return (_state$user$permissio27 = state.user.permissions[org]) === null || _state$user$permissio27 === void 0 ? void 0 : (_state$user$permissio28 = _state$user$permissio27.org_level) === null || _state$user$permissio28 === void 0 ? void 0 : _state$user$permissio28.includes('event.event.view');
}
function canUpdateEvent(state, org) {
  var _state$user$permissio29, _state$user$permissio30;
  return (_state$user$permissio29 = state.user.permissions[org]) === null || _state$user$permissio29 === void 0 ? void 0 : (_state$user$permissio30 = _state$user$permissio29.org_level) === null || _state$user$permissio30 === void 0 ? void 0 : _state$user$permissio30.includes('event.event.update');
}
function canCreateNFT(state, org) {
  var _state$user$permissio31, _state$user$permissio32;
  return (_state$user$permissio31 = state.user.permissions[org]) === null || _state$user$permissio31 === void 0 ? void 0 : (_state$user$permissio32 = _state$user$permissio31.org_level) === null || _state$user$permissio32 === void 0 ? void 0 : _state$user$permissio32.includes('nft.nft.create');
}
function canConfrimOrder(state, org) {
  var _state$user$permissio33, _state$user$permissio34;
  return (_state$user$permissio33 = state.user.permissions[org]) === null || _state$user$permissio33 === void 0 ? void 0 : (_state$user$permissio34 = _state$user$permissio33.org_level) === null || _state$user$permissio34 === void 0 ? void 0 : _state$user$permissio34.includes('payment.order.confirm');
}
function canInvalidateTickets(state, org) {
  var _state$user$permissio35, _state$user$permissio36;
  return (_state$user$permissio35 = state.user.permissions[org]) === null || _state$user$permissio35 === void 0 ? void 0 : (_state$user$permissio36 = _state$user$permissio35.org_level) === null || _state$user$permissio36 === void 0 ? void 0 : _state$user$permissio36.includes('bc.ticket.invalidate');
}
function canCreateOrganizer(state, org) {
  var _state$user$permissio37, _state$user$permissio38;
  return (_state$user$permissio37 = state.user.permissions[org]) === null || _state$user$permissio37 === void 0 ? void 0 : (_state$user$permissio38 = _state$user$permissio37.org_level) === null || _state$user$permissio38 === void 0 ? void 0 : _state$user$permissio38.includes('account.organization.create');
}
var useUserStoreDefinition = defineStore('user', {
  state: function state() {
    return getDefaultState();
  },
  getters: {
    getUser: function getUser(state) {
      return state.user;
    },
    canInviteUser: function canInviteUser(state) {
      return function (org) {
        return !!(_canInviteUser(state, org) && canGrantBcPerms(state, org));
      };
    },
    canGiveUMRole: function canGiveUMRole(state) {
      return function (org) {
        return !!(canGrantAccountPerms(state, org) && canGrantBcPerms(state, org));
      };
    },
    canGiveEMRole: function canGiveEMRole(state) {
      return function (org) {
        return !!(canGrantEventPerms(state, org) && canGrantBcPerms(state, org));
      };
    },
    canGiveOSSRole: function canGiveOSSRole(state) {
      return function (org) {
        return !!canGrantPaymentPerms(state, org);
      };
    },
    canEditPermissions: function canEditPermissions(state) {
      return function (org) {
        return !!canGrantAccountPerms(state, org);
      };
    },
    canRemovePermissions: function canRemovePermissions(state) {
      return function (org) {
        return !!(canGrantAccountPerms(state, org) && canGrantBcPerms(state, org) && canGrantEventPerms(state, org));
      };
    },
    getProfileImage: function getProfileImage(state) {
      return state.user.pictureUrl;
    },
    getUserEmail: function getUserEmail(state) {
      return state.user.email;
    },
    getOrgs: function getOrgs(state) {
      return Object.keys(state.user.permissions).filter(function (org) {
        return canListUsers(state, org);
      });
    },
    canListUsers: function canListUsers() {
      return this.getOrgs.length !== 0;
    },
    /**
     * returns organizers for users who have specified permissions
     * @param {*} state pinia state
     * @param {*} permissions array of permissions
     * @returns array of organizer names
     */
    getOrgsWithPerms: function getOrgsWithPerms(state) {
      return function (permissions) {
        return Object.keys(state.user.permissions).filter(function (org) {
          return permissions.every(function (perm) {
            var _state$user$permissio39, _state$user$permissio40;
            return (_state$user$permissio39 = state.user.permissions[org]) === null || _state$user$permissio39 === void 0 ? void 0 : (_state$user$permissio40 = _state$user$permissio39.org_level) === null || _state$user$permissio40 === void 0 ? void 0 : _state$user$permissio40.includes(perm);
          });
        });
      };
    },
    getSubOrganizers: function getSubOrganizers(state) {
      return function (orgName) {
        var hierarchy = state.user.hierarchy || {};
        return getAllSubOrganizers(hierarchy, orgName);
      };
    },
    /**
     * checks if current user has all the permissions specified (one of the roles) for the specified organizer
     * @param {*} state pinia state
     * @param {String} org name of the organizer
     * @param {Array} permissions array of permissions
     * @returns {Boolean} true/false if the user has/doesn't have specified role for the specified organizer
     */
    hasRoleForOrg: function hasRoleForOrg(state) {
      return function (org, permissions) {
        return permissions.every(function (perm) {
          var _state$user$permissio41, _state$user$permissio42;
          return !!((_state$user$permissio41 = state.user.permissions[org]) !== null && _state$user$permissio41 !== void 0 && (_state$user$permissio42 = _state$user$permissio41.org_level) !== null && _state$user$permissio42 !== void 0 && _state$user$permissio42.includes(perm));
        });
      };
    },
    canAccessDashboard: function canAccessDashboard() {
      var _this = this;
      return function (mainOrganizer, org) {
        return _this.canAccessMyEvents(org) || _this.canAccessNFTCollectibles(org) || _this.canAccessLocation(org) || _this.canAccessTransactionRules(org) || _this.canAccessOrganizer(org) || _this.canAccessUsers(org) || _this.canAccessManageAccounts(mainOrganizer);
      };
    },
    canImpersonate: function canImpersonate(state) {
      return function (org) {
        var _state$user$permissio43, _state$user$permissio44;
        return !!((_state$user$permissio43 = state.user.permissions[org]) !== null && _state$user$permissio43 !== void 0 && (_state$user$permissio44 = _state$user$permissio43.org_level) !== null && _state$user$permissio44 !== void 0 && _state$user$permissio44.includes('account.admin.impersonate'));
      };
    },
    canImpersonateAndListUsers: function canImpersonateAndListUsers(state) {
      return function (org) {
        var _state$user$permissio45, _state$user$permissio46;
        var perms = (_state$user$permissio45 = (_state$user$permissio46 = state.user.permissions[org]) === null || _state$user$permissio46 === void 0 ? void 0 : _state$user$permissio46.org_level) !== null && _state$user$permissio45 !== void 0 ? _state$user$permissio45 : [];
        return ['account.admin.impersonate', 'account.user.list'].every(function (p) {
          return perms.includes(p);
        });
      };
    },
    canInviteOrganizers: function canInviteOrganizers(state) {
      return function (org) {
        var _state$user$permissio47, _state$user$permissio48;
        var perms = (_state$user$permissio47 = (_state$user$permissio48 = state.user.permissions[org]) === null || _state$user$permissio48 === void 0 ? void 0 : _state$user$permissio48.org_level) !== null && _state$user$permissio47 !== void 0 ? _state$user$permissio47 : [];
        return ['account.organization.view', 'account.organization.update', 'account.organization.list', 'account.organization.create', 'account.organization.change_permissions'].every(function (p) {
          return perms.includes(p);
        });
      };
    },
    canUpdateOrganizer: function canUpdateOrganizer(state) {
      return function (org) {
        var _state$user$permissio49, _state$user$permissio50;
        return !!((_state$user$permissio49 = state.user.permissions[org]) !== null && _state$user$permissio49 !== void 0 && (_state$user$permissio50 = _state$user$permissio49.org_level) !== null && _state$user$permissio50 !== void 0 && _state$user$permissio50.includes('account.organization.update'));
      };
    },
    canResendEmail: function canResendEmail(state) {
      return function (org) {
        // Currently this endpoint uses the same permission as event creation
        return !!canCreateEvent(state, org);
      };
    },
    canRevokeCertificate: function canRevokeCertificate(state) {
      return function (org) {
        var _state$user$permissio51, _state$user$permissio52;
        return !!((_state$user$permissio51 = state.user.permissions[org]) !== null && _state$user$permissio51 !== void 0 && (_state$user$permissio52 = _state$user$permissio51.org_level) !== null && _state$user$permissio52 !== void 0 && _state$user$permissio52.includes('account.user.delete'));
      };
    },
    canAccessMyEvents: function canAccessMyEvents(state) {
      return function (org) {
        return !!canListEvents(state, org);
      };
    },
    canAccessNFTCollectibles: function canAccessNFTCollectibles(state) {
      return function (org) {
        return !!canCreateNFT(state, org);
      };
    },
    canAccessLocation: function canAccessLocation(state) {
      return function (org) {
        return !!canCreateLocation(state, org);
      };
    },
    canAccessTransactionRules: function canAccessTransactionRules(state) {
      return function (org) {
        return !!canUpdateOrganizer(state, org);
      };
    },
    canAccessOrganizer: function canAccessOrganizer(state) {
      return function (org) {
        return !!canUpdateOrganizer(state, org);
      };
    },
    canAccessUsers: function canAccessUsers(state) {
      return function (org) {
        return !!canListUsers(state, org);
      };
    },
    canAccessEventInfo: function canAccessEventInfo(state) {
      return function (org) {
        return !!canCreateEvent(state, org);
      };
    },
    canAccessReporting: function canAccessReporting(state) {
      return function (org) {
        return !!canViewOrganizer(state, org);
      };
    },
    canAccessSendTickets: function canAccessSendTickets(state) {
      return function (org) {
        return !!canCreateEvent(state, org);
      };
    },
    canAccessViewOrders: function canAccessViewOrders(state) {
      return function (org) {
        return !!canViewEvent(state, org);
      };
    },
    canAccessSoldTickets: function canAccessSoldTickets(state) {
      return function (org) {
        return !!canCreateEvent(state, org);
      };
    },
    canAccessSendEmails: function canAccessSendEmails(state) {
      return function (org) {
        return !!canViewEvent(state, org);
      };
    },
    canAccessManageAccounts: function canAccessManageAccounts(state) {
      return function (org) {
        return !!canListUsers(state, org);
      };
    },
    canUpdateEmails: function canUpdateEmails(state) {
      return function (org) {
        return !!canUpdateEvent(state, org);
      };
    },
    canEditUsers: function canEditUsers(state) {
      return function (org) {
        return !!canEditUser(state, org);
      };
    },
    canSendEventNotifications: function canSendEventNotifications(state) {
      return function (org) {
        return !!canViewEvent(state, org);
      };
    },
    canSendGlobalNotifications: function canSendGlobalNotifications(state) {
      return function (org) {
        return !!canEditUser(state, org);
      };
    },
    canSendNewsletter: function canSendNewsletter(state) {
      return function (mainOrganizer) {
        return !!canEditUser(state, mainOrganizer);
      };
    },
    canDeleteNewsletter: function canDeleteNewsletter(state) {
      return function (mainOrganizer) {
        return !!canDeleteUser(state, mainOrganizer);
      };
    },
    canViewNewsletter: function canViewNewsletter(state) {
      return function (mainOrganizer) {
        return !!canViewUser(state, mainOrganizer);
      };
    },
    canConvertOrder: function canConvertOrder(state) {
      return function (org) {
        return !!canCreateEvent(state, org);
      };
    },
    canAccessMobileDashboard: function canAccessMobileDashboard() {
      var _this2 = this;
      return function (org) {
        return _this2.canAccessMyEvents(org);
      };
    },
    canAccessMobileReporting: function canAccessMobileReporting() {
      var _this3 = this;
      return function (org) {
        return !!(canInvalidateTickets(_this3, org) && _this3.canAccessReporting(org));
      };
    },
    canManuallyConfirmOrder: function canManuallyConfirmOrder(state) {
      return function (org) {
        return !!canConfrimOrder(state, org);
      };
    },
    canChangeDisplayPriority: function canChangeDisplayPriority(state) {
      return function (mainOrganizer) {
        return !!canUpdateEvent(state, mainOrganizer);
      };
    },
    canAccessOrganizerLegalInfo: function canAccessOrganizerLegalInfo(state) {
      return function (org, mainOrganizer) {
        return !!(canViewOrganizer(state, org) || canViewOrganizer(state, mainOrganizer));
      };
    },
    canAccessOrganizerApplications: function canAccessOrganizerApplications(state) {
      return function (org) {
        return !!canCreateOrganizer(state, org);
      };
    },
    canAccessEventPayouts: function canAccessEventPayouts(state) {
      return function (org, mainOrganizer) {
        return !!(canViewEvent(state, org) || canViewEvent(state, mainOrganizer));
      };
    },
    canManagePayoutsForEvent: function canManagePayoutsForEvent(state) {
      return function (mainOrganizer) {
        return !!canUpdateEvent(state, mainOrganizer);
      };
    },
    getDashboardUrl: function getDashboardUrl() {
      var _this4 = this;
      return function (org, mainOrganizer) {
        if (_this4.canAccessMyEvents(org)) {
          return '/my-events';
        }
        if (_this4.canAccessNFTCollectibles(org)) {
          return '/collections';
        }
        if (_this4.canAccessLocation(org)) {
          return '/location';
        }
        if (_this4.canAccessReporting(org)) {
          return '/reporting';
        }
        if (_this4.canAccessOrganizer(org)) {
          return '/organizer/list';
        }
        if (_this4.canAccessUsers(org)) {
          return '/users';
        }
        if (_this4.canAccessManageAccounts(org, mainOrganizer)) {
          return '/manage-accounts';
        }
        return '/';
      };
    }
  },
  actions: {
    setUser: function setUser(payload) {
      var _payload$permissions;
      this.user = _objectSpread(_objectSpread({}, payload), {}, {
        permissions: (_payload$permissions = payload.permissions) !== null && _payload$permissions !== void 0 ? _payload$permissions : {}
      });
      this.loggedIn = payload.type !== 'guest';
    },
    resetUser: function resetUser() {
      Object.assign(this, getDefaultState());
    },
    // NOTE: This action updates all user object fields except permissions
    // - once the user endpoints return permissions setUser will be used instead
    updateUserData: function updateUserData(payload) {
      var _payload$permissions2;
      this.user = _objectSpread(_objectSpread(_objectSpread({}, this.user), payload), {}, {
        permissions: (_payload$permissions2 = payload.permissions) !== null && _payload$permissions2 !== void 0 ? _payload$permissions2 : this.user.permissions
      });
    }
  },
  persist: true
});

// VUE 2.7 WORKAROUND — see composables/usePinia.ts. Remove this wrapper at
// the Vue 3 flip and export useUserStoreDefinition directly as useUserStore
// instead.
export function useUserStore() {
  return useUserStoreDefinition(usePinia());
}
export { useUserStoreDefinition };